/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var CorpFinRecordHeaderBarView = require('../../common/views/CorpFinRecordHeaderBarView');

var SubmitRecord = require('../../common/services/SubmitRecord');
var CorpFinCorrespondentFormView = require('../../common/views/CorpFinCorrespondentFormView');
var CorpFinInvInvestmentDetailFormView = require('./CorpFinInvInvestmentDetailFormView');
var CorpFinInvIssuerFormView = require('./CorpFinInvIssuerFormView');

var tmplCorpFinInvestmentEditView = require('../templates/CorpFinInvestmentEditView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinInvestmentEditView,

  className: 'corp-fin-investment-edit-view container-fluid',

  ui: {
    invInvestmentDetailForm: '.inv-investment-detail-form-container',
    issuerForm: '.issuer-form-container',
    correspondentForm: '.correspondent-form-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    submit: '.submit'
  },

  regions: {
    invInvestmentDetailForm: '@ui.invInvestmentDetailForm',
    issuerForm: '@ui.issuerForm',
    correspondentForm: '@ui.correspondentForm',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var record = this.model.get('record') || {};
    var recordId = this.model.get('recordId');
    var fileNumber = record.fileNumber;

    this.showChildView(
      'headerBar',
      new CorpFinRecordHeaderBarView({
        model: new Backbone.Model(record)
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            link: '#corpfin/investment/' + recordId + '/dashboard',
            text: 'Investment (' + fileNumber + ')'
          },
          {
            text: 'Edit Investment'
          }
        ]
      })
    );

    this.issuerForm = new CorpFinInvIssuerFormView({
      model: this.model
    });

    this.invInvestmentDetailForm = new CorpFinInvInvestmentDetailFormView({
      model: this.model
    });

    this.correspondentForm = new CorpFinCorrespondentFormView({
      model: this.model
    });

    this.showChildView('issuerForm', this.issuerForm);
    this.showChildView('invInvestmentDetailForm', this.invInvestmentDetailForm);
    this.showChildView('correspondentForm', this.correspondentForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.getFormData();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitRecord(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:cf:investment-dashboard', self.model.get('recordId'));
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    var validationArray = [
      this.ui.issuerForm.parsley().whenValidate(),
      this.ui.invInvestmentDetailForm.parsley().whenValidate(),
      this.ui.correspondentForm.parsley().whenValidate()
    ];

    return $.when.apply($, validationArray);
  },

  getFormData: function() {
    var record = this.model.get('record') || {};

    var recordDetails = {
      reecordId: this.model.get('recordId'),
      currentRecordName: record.recordName,
      recordTypeId: record.recordTypeId,
      recordCategoryId: '3' //investment
    };

    var formData = _.extend(
      recordDetails,
      this.issuerForm.getFormData(),
      this.invInvestmentDetailForm.getFormData(),
      this.correspondentForm.getFormData()
    );

    return formData;
  }
});
